import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderV2Component } from './header-v2.component';
import { IonicModule } from '@ionic/angular';



@NgModule({
  declarations: [HeaderV2Component],
  exports: [HeaderV2Component],
  imports: [
    CommonModule,
    IonicModule,
  ]
})
export class HeaderV2Module { }
